// src/services/cardStrings.js
//
// 🟥 THE SHARED-VIBE CARD WAS THE LAST ALL-ENGLISH SURFACE IN THE CHAT. "Suggested
//    post", "Post locked", "Set up Vibes to view", "View post", "Allo user" — all
//    typed inline in ChatWindow, beside a bubble whose every other word already
//    came from a table. A Spanish reader got a Spanish chat with an English card
//    in the middle of it, and the one line that ASKS them to do something (set up
//    Vibes, or wait for a birthday) was the line they could not read.
//
// 🟢 SAME SHAPE AS modStrings.js, deliberately — that file already solved this for
//    moderation, with the same ten languages, the same `pickLang`, and the same
//    {{…}} placeholders the app's i18n and the server's L() use. A second pattern
//    for one job is one more thing to keep in step.
//
// 🟥 AND THE WORDS ARE THE APP'S OWN, COPIED VERBATIM from allo-app/locales/*.json
//    — not re-translated here. Hand-typing them is exactly how this drifts: the
//    first draft of this file said "Рекомендуемый пост" where the app says
//    "Рекомендованное", which nobody would ever report and every Russian reader
//    would half-notice. gtest/sharedvibe.test.mjs diffs this table against those
//    files, key by key, in all ten languages.
import { pickLang } from './modStrings';

const T = {
  suggested_post: {
    en: 'Suggested Post', es: 'Publicación sugerida', fr: 'Publication suggérée',
    de: 'Vorgeschlagener Beitrag', zh: '推荐帖子', ja: 'おすすめの投稿',
    ru: 'Рекомендованное', ar: 'منشور مقترح', pt: 'Post Sugerido',
    hi: 'सुझाया गया पोस्ट',
  },
  post_locked: {
    en: 'Post Locked', es: 'Publicación bloqueada', fr: 'Publication verrouillée',
    de: 'Beitrag gesperrt', zh: '帖子已锁定', ja: '投稿はロックされています',
    ru: 'Пост скрыт', ar: 'المنشور مقفل', pt: 'Post Bloqueado',
    hi: 'पोस्ट लॉक है',
  },
  view_post: {
    en: 'View Post', es: 'Ver publicación', fr: 'Voir la publication',
    de: 'Beitrag ansehen', zh: '查看帖子', ja: '投稿を表示',
    ru: 'Открыть пост', ar: 'عرض المنشور', pt: 'Ver Post',
    hi: 'पोस्ट देखें',
  },
  unknown_user: {
    en: 'Unknown User', es: 'Usuario desconocido', fr: 'Utilisateur inconnu',
    de: 'Unbekannter Nutzer', zh: '未知用户', ja: '不明なユーザー',
    ru: 'Неизвестный пользователь', ar: 'مستخدم مجهول', pt: 'Usuário desconhecido',
    hi: 'अज्ञात उपयोगकर्ता',
  },
  setup_vibes: {
    en: 'Setup Vibes', es: 'Configurar Vibes', fr: 'Configurer Vibes',
    de: 'Vibes einrichten', zh: '设置 Vibes', ja: 'Vibesを設定',
    ru: 'Настроить Vibes', ar: 'إعداد Vibes', pt: 'Configurar Vibes',
    hi: 'Vibes सेटअप करें',
  },
  view_timer: {
    en: 'View Timer', es: 'Ver temporizador', fr: 'Voir le minuteur',
    de: 'Timer anzeigen', zh: '查看计时器', ja: 'タイマーを表示',
    ru: 'Таймер', ar: 'عرض المؤقت', pt: 'Ver Temporizador',
    hi: 'टाइमर देखें',
  },
  vibe_card_setup_to_view: {
    en: 'Set up Vibes to view', es: 'Configura Vibes para ver', fr: 'Configurez Vibes pour voir',
    de: 'Vibes einrichten zum Ansehen', zh: '设置 Vibes 后查看', ja: '表示するには Vibes を設定',
    ru: 'Настройте Vibes, чтобы посмотреть', ar: 'قم بإعداد Vibes للعرض', pt: 'Configure o Vibes para ver',
    hi: 'देखने के लिए Vibes सेट करें',
  },
  vibe_card_available_on: {
    en: 'Available on {{date}}', es: 'Disponible el {{date}}', fr: 'Disponible le {{date}}',
    de: 'Verfügbar am {{date}}', zh: '{{date}} 起可查看', ja: '{{date}} から利用可能',
    ru: 'Будет доступно {{date}}', ar: 'متاح في {{date}}', pt: 'Disponível em {{date}}',
    hi: '{{date}} को उपलब्ध',
  },
  vibe_card_age_restricted: {
    en: 'Age restricted', es: 'Restringido por edad', fr: 'Limite d’âge',
    de: 'Altersbeschränkt', zh: '有年龄限制', ja: '年齢制限あり',
    ru: 'Возрастное ограничение', ar: 'مقيّد بالعمر', pt: 'Restrito por idade',
    hi: 'आयु प्रतिबंधित',
  },
  vibe_card_setup_required: {
    en: 'Setup required', es: 'Configuración necesaria', fr: 'Configuration requise',
    de: 'Einrichtung nötig', zh: '需要先设置', ja: '設定が必要',
    ru: 'Нужна настройка', ar: 'الإعداد مطلوب', pt: 'Configuração necessária',
    hi: 'सेटअप आवश्यक',
  },
  vibe_card_more_options: {
    en: '+{{count}} more', es: '+{{count}} más', fr: '+{{count}} de plus',
    de: '+{{count}} weitere', zh: '还有 {{count}} 项', ja: '他 {{count}} 件',
    ru: 'ещё {{count}}', ar: '+{{count}} أخرى', pt: 'mais {{count}}',
    hi: '+{{count}} और',
  },
  vibe_card_vote_on_post: {
    en: 'Vote on post', es: 'Vota en la publicación', fr: 'Voter sur la publication',
    de: 'Im Beitrag abstimmen', zh: '在帖子中投票', ja: '投稿で投票',
    ru: 'Голосовать в посте', ar: 'صوّت في المنشور', pt: 'Votar no post',
    hi: 'पोस्ट पर वोट करें',
  },
  vibe_card_results_final: {
    en: 'Final results', es: 'Resultados finales', fr: 'Résultats finaux',
    de: 'Endergebnis', zh: '最终结果', ja: '最終結果',
    ru: 'Итоговые результаты', ar: 'النتائج النهائية', pt: 'Resultados finais',
    hi: 'अंतिम परिणाम',
  },
  vibe_card_from_chat: {
    en: 'Shared with you', es: 'Compartido contigo', fr: 'Partagé avec vous',
    de: 'Mit dir geteilt', zh: '分享给你的', ja: 'あなたに共有',
    ru: 'Поделились с вами', ar: 'تمت مشاركته معك', pt: 'Compartilhado com você',
    hi: 'आपके साथ साझा किया गया',
  },
  b12_poll_no_votes: {
    en: 'No votes yet', es: 'Sin votos aún', fr: 'Aucun vote',
    de: 'Noch keine Stimmen', zh: '暂无投票', ja: 'まだ投票はありません',
    ru: 'Голосов пока нет', ar: 'لا توجد أصوات بعد', pt: 'Sem votos ainda',
    hi: 'अभी तक कोई वोट नहीं',
  },
  b12_poll_vote_count_one: {
    en: '1 vote', es: '1 voto', fr: '1 vote',
    de: '1 Stimme', zh: '1 票', ja: '1 票',
    ru: '1 голос', ar: 'صوت واحد', pt: '1 voto',
    hi: '1 वोट',
  },
  b12_poll_vote_count_other: {
    en: '{{count}} votes', es: '{{count}} votos', fr: '{{count}} votes',
    de: '{{count}} Stimmen', zh: '{{count}} 票', ja: '{{count}} 票',
    ru: '{{count}} голосов', ar: '{{count}} أصوات', pt: '{{count}} votos',
    hi: '{{count}} वोट',
  },
};

/** The languages this table covers — the app's ten, no more and no fewer. */
export const CARD_LANGS = ['en', 'es', 'fr', 'de', 'zh', 'ja', 'ru', 'ar', 'pt', 'hi'];

/**
 * One card string, in `lang` (default: the browser's).
 *
 * 🟢 Falls back to English, then to '' — NEVER to the key name. A missing
 *    translation should read as a gap, not as `vibe_card_vote_on_post` printed in
 *    the middle of somebody's chat.
 */
export function ct(key, params, lang) {
  const row = T[key];
  if (!row) return '';
  let s = row[lang || pickLang()] || row.en || '';
  if (params) {
    for (const k of Object.keys(params)) s = s.split(`{{${k}}}`).join(String(params[k]));
  }
  return s;
}

/** The whole table, for the suite that diffs it against the app's locales. */
export const CARD_STRINGS = T;
